import { JarvisAuthPages, useDynamicConfig } from "@dgs/core";
import React, { FC } from "react";

export const AMAuthPages: FC = () => {
	const { authUrl } = useDynamicConfig();

	return <JarvisAuthPages authUrl={authUrl} showPasswordReset={true} />;
};
